(() => {
  const config = document.querySelector('script[data-sku-index]');
  if (!config) return;
  const indexUrl = new URL(config.dataset.skuIndex, location.origin);
  const cacheKey = `denhartog-skus-v1:${indexUrl.pathname}:${config.dataset.theme}`;
  const ttl = 15 * 60 * 1000;
  let pendingIndex;

  function isArticleNumber(value) {
    return /^\d[\da-z.\-]*$/i.test(value.trim());
  }

  function aliases(sku) {
    return sku.trim().replace(/^[a-z]+[\s-]*/i, '').toLowerCase();
  }

  async function getIndex() {
    if (pendingIndex) return pendingIndex;
    pendingIndex = (async () => {
      try {
        const cached = JSON.parse(sessionStorage.getItem(cacheKey));
        if (cached?.expires > Date.now() && Array.isArray(cached.skus)) return cached.skus;
      } catch (_) {}
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 20000);
      try {
        async function page(number) {
          const url = new URL(indexUrl);
          url.searchParams.set('page', number);
          const response = await fetch(url, { signal: controller.signal, credentials: 'same-origin' });
          if (!response.ok) throw new Error('SKU index unavailable');
          const data = await response.json();
          if (data.version !== 1 || !Array.isArray(data.skus) || data.page !== number || !Number.isInteger(data.pages) || data.pages > 100) throw new Error('Invalid SKU index');
          return data;
        }
        const first = await page(1);
        const skus = [...first.skus];
        let next = 2;
        await Promise.all(Array.from({ length: Math.max(0, Math.min(4, first.pages - 1)) }, async () => {
          while (next <= first.pages) {
            const data = await page(next++);
            skus.push(...data.skus);
          }
        }));
        const unique = [...new Set(skus.filter(sku => typeof sku === 'string' && sku.trim()).map(sku => sku.trim()))];
        try { sessionStorage.setItem(cacheKey, JSON.stringify({ expires: Date.now() + ttl, skus: unique })); } catch (_) {}
        return unique;
      } finally {
        clearTimeout(timeout);
      }
    })().catch(error => { pendingIndex = undefined; throw error; });
    return pendingIndex;
  }

  async function resolve(term) {
    if (!isArticleNumber(term)) return term;
    const numeric = term.trim().toLowerCase();
    const skus = await getIndex();
    let matches = skus.filter(sku => aliases(sku) === numeric);
    if (!matches.length && numeric.length >= 3) matches = skus.filter(sku => aliases(sku).startsWith(numeric));
    if (!matches.length || matches.length > 100) return term;
    const quote = sku => JSON.stringify(sku);
    return [...new Set(matches)].sort().map(sku => `variants.sku:${quote(sku)}`).join(' OR ');
  }

  function searchInput(form) {
    return form.querySelector('input[name="q"]');
  }

  function isSearchForm(form) {
    return form instanceof HTMLFormElement && new URL(form.action, location.origin).pathname.replace(/\/$/, '').endsWith('/search') && searchInput(form);
  }

  function searchUrl(form, original, query) {
    const url = new URL(form.action, location.origin);
    url.search = new URLSearchParams(new FormData(form)).toString();
    url.searchParams.set('q', query);
    url.searchParams.delete('page');
    if (query !== original) url.searchParams.set('sa_q', original);
    else url.searchParams.delete('sa_q');
    return url;
  }

  document.addEventListener('input', event => {
    const input = event.target;
    if (input.name === 'q' && input.value.trim().length >= 3 && isSearchForm(input.form) && isArticleNumber(input.value)) getIndex().catch(() => {});
  });

  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!isSearchForm(form)) return;
    const input = searchInput(form);
    const original = input.value.trim();
    if (!isArticleNumber(original)) return;
    event.preventDefault();
    if (form.dataset.skuPending) return;
    form.dataset.skuPending = 'true';
    form.setAttribute('aria-busy', 'true');
    let query = original;
    try { query = await resolve(original); } catch (_) {}
    delete form.dataset.skuPending;
    form.removeAttribute('aria-busy');
    if (input.value.trim() !== original) return;
    location.assign(searchUrl(form, original, query));
  }, true);

  const params = new URLSearchParams(location.search);
  const original = params.get('sa_q');
  const query = params.get('q');
  const main = document.querySelector('main');
  if (original && isArticleNumber(original) && query && query.startsWith('variants.sku:')) {
    document.querySelectorAll('form input[name="q"]').forEach(input => { input.value = original; });
    if (main) {
      const walker = document.createTreeWalker(main, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) {
        const node = walker.currentNode;
        if (!node.parentElement.closest('script, style') && node.textContent.includes(query)) node.textContent = node.textContent.replaceAll(query, original);
      }
    }
    document.title = document.title.replaceAll(query, original);
  } else if (!original && query && isArticleNumber(query) && location.pathname.replace(/\/$/, '').endsWith('/search')) {
    resolve(query).then(resolved => {
      if (resolved === query) return;
      const url = new URL(location.href);
      url.searchParams.set('q', resolved);
      url.searchParams.set('sa_q', query);
      url.searchParams.delete('page');
      location.replace(url);
    }).catch(() => {});
  }
  window.DenHartogSkuSearch = { resolve };
})();

